import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getBrandTermCondition = brandId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/term-condition',
    headers: getHeaders(),
  });
};

export const postBrandTermCondition = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/term-condition',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putBrandTermCondition = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/term-condition',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};